import React, { useContext, useEffect } from "react";
import { Dropdown, Image } from "react-bootstrap";
import IconBtn from "../../components/IconBtn";
import logo from "../../../static/logo.png";
import cnlogo from "../../../static/cn_logo.png";
import { MoonOutlined, SaveOutlined, SunOutlined } from "@ant-design/icons";
import MyContext from "../Mycontext";
import "./index.css";
import { useTranslation } from "react-i18next";
import Chatting from "../Chatting";
import ChooseCard from "../ChooseCard";
import { Avatar } from "antd";
import { useTheme } from "../../../providers/CustomThemeProvider";
import Headers from "../Headers";

import refresh from "../../../static/icon/refresh.svg";
import openboxIcon from "../../../static/icon/openbox.svg";
import lightOpenboxIcon from "../../../static/light-icon/lightopenbox.svg";
import Settings from "../../../static/icon/Settings.svg";
import lightSettings from "../../../static/light-icon/Settings.svg";
import contentPaste from "../../../static/icon/content_paste.svg";
import lightContentPaste from "../../../static/light-icon/content_paste.svg";

const Greeting = (props: any) => {
	const { t, i18n } = useTranslation();
	const { hideSide, onHideSide, recordList, setRecordList } = props;

	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const {
		requireType,
		setRequireType,
		file,
		fileUrl,
		setFile,
		setFileUrl,
		handleChange,
	} = context;
	const { isDarkMode, switchTheme } = useTheme();

	useEffect(() => {
		setRequireType && setRequireType("text");
	}, []);

	return (
		<div className="greeting">
			{/* 新建默认展示页面 */}
			<Headers />
			<div className="greeting-title">
				{/* 招呼语 */}
				{/* {i18n.language == "en" ? (
					<Image src={logo} className="doctaChat-logo" />
				) : (
					<Image src={cnlogo} className="doctaChat-logo" />
				)} */}
				<div className="greeting-gradient">
					欢迎使用第五维度点灵数据搜集平台！
				</div>
				<div className="doctaChat-text">
					您只需通过选择所需要的数据类型，输入简单描述，我们就能为您找到合适的数据！
					<br />
					第五维度随时为您服务~ 😊
				</div>
			</div>
			<ChooseCard />
			{/* <div className="chatting-input-wrapper-btn-group">
				<IconBtn
					selected={requireType === "text"}
					icon={<SaveOutlined />}
					text={"文本任务"}
					onClick={() => {
						setRequireType && setRequireType("text");
					}}
				/>
				<IconBtn
					selected={requireType === "img"}
					icon={<SaveOutlined />}
					text={"图片任务"}
					onClick={() => {
						setRequireType && setRequireType("img");
						// setUploadVisible(true);
					}}
				/>
				<IconBtn
					selected={requireType === "video"}
					icon={<SaveOutlined />}
					text={"视频任务"}
					onClick={() => {
						setRequireType && setRequireType("video");
						console.log(`创建"video" 任务`);
						// setUploadVisible(true);
					}}
					disabled={true}
				/>
				<IconBtn
					selected={requireType === "audio"}
					icon={<SaveOutlined />}
					text={"音频任务"}
					onClick={() => {
						setRequireType && setRequireType("audio");
						console.log(`创建"audio" 任务`);
					}}
					disabled={true}
				/>
			</div> */}
			{/* <div className="formContainer"> */}
			<Chatting />
			{/* </div> */}
		</div>
	);
};

export default Greeting;
